/* eslint-disable no-unused-vars */
/**
 * /* eslint-disable no-restricted-globals
 *
 * @format
 */

import { is_touch_device } from '../../../utils'

function rand(min, max) {
  return Math.random() * (max - min) + min
}

var canvas
var splash
var context
var keyOn = []
var gamma
var level
var propBlocksPerLevel

var block1
var block2

var assistVar

let debug = false
let setScore = false

var Movable = function(data) {
  if (data === undefined) return

  for (var i = 0; i < data.length; i++) {
    var setting = data[i]

    // By accessing 'this' (which refers to this very instance) as an array, we can set a new object-specific variable with the name of 'setting' to 'setting' its value
    this[setting[0]] = setting[1]
  }

  this.alive = true
}

Movable.prototype = {
  update: function() {
    if (this.alive) {
      this.move()
      this.draw()
    }
  },

  draw: function() {
    context.drawImage(
      this.src,
      0,
      0,
      this.width,
      this.height,
      this.x,
      this.y,
      this.sWidth,
      this.sHeight,
    )
    // context.strokeRect(this.x, this.y, this.sWidth, this.sHeight);
  },
}

var Countable = function() {
  this.x = 0
  this.y = 0

  this.speed = 2

  this.value = 0
  this.targetValue = 0
}
Countable.prototype = {
  update: function() {
    this.move()
    this.draw()
  },

  change: function(amount) {
    this.targetValue += amount
    setScore(this.targetValue)
  },

  move: function() {
    // The move routine should only be executed if the actual value is not identical to the target value
    if (this.value === this.targetValue) return

    // If the difference between the target and actual value is lower than the animation speed, set the value to the target value
    if (Math.abs(this.value - this.targetValue) < this.speed)
      if (
        typeof DeviceMotionEvent !== 'undefined' &&
        typeof DeviceMotionEvent.requestPermission === 'function'
      )
        this.value = this.targetValue * -1
      else this.value = this.targetValue
    else if (this.targetValue > this.value) this.value += this.speed
    else this.value -= this.speed
  },
}

var Basket = function(data) {
  Movable.call(this, data)
  this.reset()
}
Basket.prototype = new Movable()
Basket.prototype.reset = function() {
  // Reset the position
  this.x = canvas.width / 2 - this.sWidth / 2
  this.y = canvas.height - this.sHeight
}
Basket.prototype.move = function() {
  // 37 is the keycode representation of a left keypress
  if (keyOn[37]) this.x -= this.xSpeed
  // this.x -= this.xSpeed * level;

  // 39 is the keycode representation of a right keypress
  if (keyOn[39]) this.x += this.xSpeed
  // this.x += this.xSpeed * level;

  // If the x co-ordinate is lower than 0, which is less than the outer left position of the canvas, move it back to the outer left position of the canvas
  if (this.x < -25) this.x = -25

  // If the x co-ordinate plus the basket its width is greater than the canvas its width, move it back to the outer right position of the canvas
  if (this.x + this.width / 2 > canvas.width + 25)
    this.x = canvas.width - this.width / 2 + 25
}

var Block = function(data) {
  Movable.call(this, data)

  this.initSrc()
  this.initPosition()
}
Block.prototype = new Movable()
Block.prototype.initPosition = function() {
  // Only allow to set the position of this block once
  if (this.x !== undefined || this.y !== undefined) return

  // By picking a rounded number between 0 and the canvas.width substracted by the block its width, we have a position for this block which is still inside the block its viewport
  this.x = Math.round(rand(0, canvas.width - this.width))

  // By setting the vertical position of the block to 0 substracted by the block its height, the block will look like it slides into the canvas its viewport
  this.y = 0 - this.height
}
Block.prototype.initSrc = function() {
  if (this.src !== undefined) return

  assistVar = Math.round(rand(0, addToBasket.srcs.length - 1))
  this.width = this.sWidth = addToBasket.srcs[assistVar][0][1]
  this.height = this.sHeight = addToBasket.srcs[assistVar][1][1]
  this.src = addToBasket.srcs[assistVar][2][1]
}
Block.prototype.move = function() {
  // Add the vertical speed to the block its current position to move it
  this.y += this.ySpeed * level
  // this.y += this.ySpeed * level;

  this.sWidth =
    this.width - (this.width - this.width / 10) / (canvas.height / this.y)
  this.sHeight =
    this.height - (this.height - this.height / 10) / (canvas.height / this.y)
}

var Score = function() {
  Countable.call(this)

  this.x = canvas.width - 15
  this.y = 15
}
Score.prototype = new Countable()

Score.prototype.reset = function() {
  this.value = this.targetValue = 0
}
Score.prototype.draw = function() {
  if (!debug) {
    return
  }

  context.textBaseline = 'top'
  context.fillStyle = '#000'
  context.fillText(this.value, this.x, this.y)
  context.fillText('PT', this.x - 25, this.y)
}

var blockImages = function() {
  var imgArr = []
  var imgs = [
    [
      ['width', 107.98],
      ['height', 112],
      ['src', 'block-1.png'],
    ],
    [
      ['width', 118],
      ['height', 118],
      ['src', 'block-2.png'],
    ],
    [
      ['width', 118],
      ['height', 128],
      ['src', 'block-3.png'],
    ],
    [
      ['width', 116],
      ['height', 120],
      ['src', 'block-4.png'],
    ],
  ]
  for (var i = 0; i < imgs.length; i++) {
    var newImg = new Image(imgs[i][0][1], imgs[i][1][1])
    newImg.src = 'assets/' + imgs[i][2][1]
    imgArr[i] = [
      ['width', imgs[i][0][1]],
      ['height', imgs[i][1][1]],
      ['src', newImg],
    ]
  }

  return imgArr
}

var addToBasket = new (function() {
  this.srcs = blockImages()

  var basketImage = new Image(158, 331)
  basketImage.src = 'assets/basket.png'

  var basketData = [
    ['width', 158],
    ['height', 331],
    ['sWidth', 79],
    ['sHeight', 165],
    ['xSpeed', 5],
    ['src', basketImage],
  ]
  var blockData = [
    ['width', undefined],
    ['height', undefined],
    ['sWidth', undefined],
    ['sHeight', undefined],
    ['ySpeed', 6],
    ['src', undefined],
    ['strength', 1],
  ]

  var blocksPerLevel = propBlocksPerLevel
  var blocksSpawnSecStart = is_touch_device() ? 0.5 : 1.2
  var blocksSpawnSec = 0
  var blocksSpawned = 0
  var blocksOnScreen = 0
  var blocks = []
  var interval = false
  var timeout = false
  var delay = false

  var totalLevels = 1
  var levelUp

  var basket
  var sensitivity = 6
  var score

  var info = null
  var infoScreenChange = true

  var startTime
  var frameTime

  this.run = function(opts) {
    opts = opts || {}

    blocksPerLevel = opts.blocksPerLevel

    splash = document.getElementById('splash')
    // block1 = document.querySelector('.block-1')
    // block2 = document.querySelector('.block-2')

    // Set the global 'canvas' object to the #canvas DOM object to be able to access its width, height and other attributes are
    canvas = document.getElementById('canvas')

    canvas.width = window.gameWidth >= 880 ? 880 : window.gameWidth
    // canvas.width = window.gameWidth
    canvas.height = window.gameHeight

    // Increase the basket speed for desktop
    if (canvas.width >= 880) basketData[4][1] = 10

    // Change block speed for desktop
    if (!is_touch_device()) blockData[4][1] = 5
    // Change block speed for mobile
    if (is_touch_device()) blockData[4][1] = 8

    // This is where its all about; getting a new instance of the C2A object — pretty simple huh?
    context = canvas.getContext('2d')

    // Add an eventListener for the global keydown event
    document.addEventListener(
      'keydown',
      function(event) {
        // Add the keyCode of this event to the global keyOn Array
        // We can then easily check if a specific key is pressed by simply checking whether its keycode is set to true
        keyOn[event.keyCode] = true
      },
      false,
    )

    // Add another eventListener for the global keyup event
    document.addEventListener(
      'keyup',
      function(event) {
        // Set the keyCode of this event to false, to avoid an inifinite keydown appearance
        keyOn[event.keyCode] = false
      },
      false,
    )

    // Instantiate required objects
    basket = new Basket(basketData)
    score = new Score()

    // Set the infoScreenChange variable to its default value again
    infoScreenChange = true

    setTimeout(function() {
      // Set the CSS 'display' rule of the info element to none so it disappears
      // info && info.style.display = 'none';

      // The player wants to start playing so the current 'titleScreen loop' will be cleared
      interval && clearInterval(interval)

      // Reset the game
      resetGame()

      // Enter the game loop at 40 frames per second
      interval = setInterval(gameLoop, 10)
    }, 1000)

    window.addEventListener('deviceorientation', handleOrientation)
  }

  function resetGame() {
    basket.reset()
    score.reset()

    basket.alive = true
    blocksSpawnSec = blocksSpawnSecStart
    blocksSpawned = 0
    blocksOnScreen = 0
    blocks = []
    level = 1
    startTime = new Date().getTime()
  }

  function resetLevel() {
    basket.reset()
    blocksSpawned = 0
    blocksOnScreen = 0
    blocks = []
  }

  function handleOrientation(event) {
    var x = event.gamma // In degree in the range [-90,90]
    var left = canvas.width / 2 - basket.sWidth / 2 + x * (sensitivity * level)
    if (left > -25 && left + basket.width / 2 < canvas.width + 25)
      basket.x = left
  }

  function titleScreen() {
    // Should the info screen be updated?
    if (infoScreenChange) {
      // Set the HTML value of the info DOM object so it displays a fancy titlescreen
      //   info && info.innerHTML = '';

      // splash.style.display = 'block'

      // Only update the info screen once
      infoScreenChange = false
    }
  }

  function gameOverScreen() {
    frameTime = new Date().getTime()

    // Should the info screen be changed?
    if (infoScreenChange) {
      // First clear the canvas with the basket and blocks from the background
      context.clearRect(0, 0, canvas.width, canvas.height)

      //   info && info.style.display = 'block';

      // Do not update the info screen again
      infoScreenChange = false
    }

    // If three seconds have passed
    if (frameTime > startTime + 3 * 1000) {
      // A new info screen should be pushed next time
      infoScreenChange = true

      // Reset the timer
      startTime = frameTime

      // Quit this loop and set a new the loop for the title screen
      clearInterval(interval)
      // interval = setInterval(titleScreen, 10);
      interval = setInterval(titleScreen, 30 / 1000)

      // fadeSplash()
    }
  }

  function gameLoop() {
    frameTime = new Date().getTime()

    if (level > totalLevels) {
      infoScreenChange = true
      basket.alive = false

      // Abort the game loop and set a new loop for the game over screen
      clearInterval(interval)
      interval = setInterval(gameOverScreen, 30 / 1000)

      return
    }

    if (levelUp) {
      if (infoScreenChange) {
        // First clear the canvas with the basket and blocks from the background
        context.clearRect(0, 0, canvas.width, canvas.height)

        // Change the text of the info screen and show it
        // info && info.innerHTML = '<p>Level ' + (level-1) + ' cleared!</p><p>Get ready for level ' + level + '!</p>';
        // info && info.style.display = 'block';

        // Do not update the info screen again
        infoScreenChange = false
      }

      // If three seconds have passed
      if (frameTime >= startTime + 3 * 1000) {
        score.reset()
        // Flashing of the message has been completed
        levelUp = false

        // Hide the info screen and force an update next time
        // info && info.style.display = 'none';
        infoScreenChange = true

        // Set a new timer
        startTime = frameTime
      }

      return
    }

    context.clearRect(0, 0, canvas.width, canvas.height)

    basket.update()
    // health.update();
    score.update()

    updateBlocks()

    // blocksSpawnSec * 1000 because the timer values are in miliseconds
    if (frameTime >= startTime + blocksSpawnSec * 1000) {
      if (score.value >= 35) {
        // The player should go up a level
        levelUp = true
        level++
        infoScreenChange = true

        // Change the text of the info screen and show it
        //   info && info.innerHTML = '<p>Well done!</p>';

        // blocksSpawnSec = blocksSpawnSec / (1 + (1/level));
        blocksSpawnSec *= 0.9
        blockData['ySpeed'] *= 1.4
        basketData['xSpeed'] *= 1.02

        // Reset level specific variables
        resetLevel()

        basket.alive = false

        // Abort the game loop and set a new loop for the game over screen
        clearInterval(interval)
        interval = setInterval(gameOverScreen, 30 / 1000)
      }

      if (
        blocksSpawned > parseInt(blocksPerLevel * 0.3) &&
        blocksSpawned < parseInt(blocksPerLevel * 0.6)
      ) {
        if (is_touch_device()) blocksSpawnSec = 0.4
        else blocksSpawnSec = 0.85
      } else if (blocksSpawned >= parseInt(blocksPerLevel * 0.6)) {
        if (is_touch_device()) blocksSpawnSec = 0.3
        else blocksSpawnSec = 0.65
      }

      // If all blocks have been added
      if (addBlock() === false) {
        if (blocksPerLevel === blocksSpawned && score.value >= 35) {
          // The player should go up a level
          levelUp = true
          level++
          infoScreenChange = true

          // Change the text of the info screen and show it
          //   info && info.innerHTML = '<p>Well done!</p>';

          // blocksSpawnSec = blocksSpawnSec / (1 + (1/level));
          blocksSpawnSec *= 0.9
          blockData['ySpeed'] *= 1.4
          basketData['xSpeed'] *= 1.02

          // Reset level specific variables
          resetLevel()
        } else {
          setTimeout(function() {
            infoScreenChange = true
            basket.alive = false

            // Abort the game loop and set a new loop for the game over screen
            clearInterval(interval)
            interval = setInterval(gameOverScreen, 30 / 1000)
          }, 1000)

          return
        }
      }

      // The timer is finished, reset it
      startTime = frameTime
    }
  }

  function updateBlocks() {
    for (var i = 0; i < blocks.length; i++) {
      // Assign a local copy
      var block = blocks[i]

      block.update()
      checkCollision(block)
    }
  }

  // By passing a reference of the block object to the function, we can use the current very block to perform our collision detection
  function checkCollision(block) {
    if (block === undefined || block.alive === false) return

    // If the block hasn't passed the vertical line the basket resides on, we're not dealing with a collision (yet)
    if (
      block.y + block.sHeight > basket.y + 15 &&
      block.y + block.sHeight < basket.y + 40
    ) {
      if (
        block.x > basket.x &&
        block.x + block.sWidth < basket.x + basket.sWidth + 15
      ) {
        // Whether its a correctly colored block or not, the current block should disappear and the amount of blocks on the screen should decrease with one
        if (block.alive === true) {
          block.alive = false
          blocksOnScreen--
        }

        // So give the player some points
        score.change(block.strength)
        if (window.navigator.vibrate) window.navigator.vibrate(5)
      }
      // If it's not, the block has missed the basket and will thus, eventually, collide with the ground
      else {
        // If the block its y co-ordinate is greater than the canvas its height, it has disappeared from the viewport and can be removed
        if (block.alive === true && block.y + block.sHeight > canvas.height) {
          block.alive = false
          blocksOnScreen--
        }
      }
    } else {
      return
    }
  }

  function addBlock() {
    if (blocksSpawned < blocksPerLevel * level) {
      // Add a new block the the blocks array
      blocks[blocks.length] = new Block(blockData)

      // Both increase the amount of blocks on the screen and the amount of spawned blocks
      blocksSpawned++
      blocksOnScreen++
    } else {
      // Check whether all blocks have been processed
      // if (blocksOnScreen == 0)
      return false
    }

    // Return true if there's still something to work with
    return true
  }
})()

export function initGame(opts) {
  opts = opts || {}

  setScore = opts.onCollect
  debug = opts.debug
  propBlocksPerLevel = opts.blocksPerLevel

  addToBasket.run(opts)
}
